import moment from 'moment';

export default function datetime (date) {
    let aux = moment(date, "YYYY-MM-DD HH:mm:ss");
    if(aux.isValid()){
        return aux.format("DD/MM/YYYY HH:mm");
    }

    return date;
}